export default {
  methods: {
    cerrar() {
      this.imagenesZoom = [];
      this.mostrarVentanaZoomImagen = !this.mostrarVentanaZoomImagen;
    },
    descargarImagen(imagen, partida) {
      this.imagenSeleccionDescarga = imagen;
      const imagenSelect = partida.imagenes.findIndex((i) => i.imagen === imagen) + 1;
      const { fecha } = partida.imagenes.find((i) => i.imagen === imagen);
      const partidaConcepto = partida.concepto.substring(0, 99);
      const nombreArchivo = `${this.contratoNumero}_${partidaConcepto}_f${imagenSelect}_${fecha}`;
      const data = { publicKey: imagen, nombreArchivo };
      this.mixDescargarImagen(data);
    },
    clickMostrarVentanaZoomImagen(partidaImagenes, imagen) {
      const imagenSelect = partidaImagenes.findIndex((i) => i.imagen === imagen);
      const ordenImagenesUno = partidaImagenes.slice(imagenSelect, partidaImagenes.length);
      const ordenImagenesDos = partidaImagenes.slice(0, imagenSelect);
      this.imagenesZoom = [...ordenImagenesUno, ...ordenImagenesDos];
      this.mostrarVentanaZoomImagen = !this.mostrarVentanaZoomImagen;
    },

    descargarZip(partida) {
      this.imagenSeleccionDescarga = partida.idpartida;
      const SoloPublicKeys = this.getSoloPublicKeys(partida.imagenes);
      const partidaConcepto = partida.concepto.substring(0, 99);
      const nombreArchivo = `${this.contratoNumero}_${partidaConcepto}_fotos`;
      const data = { SoloPublicKeys, nombreArchivo, contratoNumero: this.contratoNumero };
      this.mixDescargaImagenesZip(data);
    },
    getSoloPublicKeys(partidaImagenes) {
      let SoloPublicKeys = [];
      if (!partidaImagenes) SoloPublicKeys = [];
      else {
        SoloPublicKeys = partidaImagenes.map((i) => i.imagen);
      }
      return SoloPublicKeys;
    },
  },
  computed: {

    getContratoFotos() {
      if (!this.reportesFisicos) return [];
      let partidas = {};
      /* Si el album es llamado desde el modulo de consulta aplica
         el criterio de mostrar solo las últimas fotos de cada partida,
         de lo contrario utiliza el siguiente criterio que es todas
         las fotos de cada partida, ordenadas de la más antigua a la
         más reciente */
      if (this.modulo === 'consultas') {
        partidas = this.reportesFisicos
          .map(
            (r) => r.partidas.map((p) => (
              {
                idpartida: p.idPartida,
                concepto: p.partida.concepto,
                fecha: p.fecha ? p.fecha : r.fecha,
                avanceFisico: p.avanceFisico,
                imagenes: p.imagenes,
              }))
              .filter((p) => p.imagenes !== null),
          ).filter((p) => p.length > 0).flat(2)
          .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
          .sort((a, b) => {
            if (a.concepto < b.concepto) { return -1; }
            if (a.concepto > b.concepto) { return 1; }
            return 0;
          });
        const partidasUnicas = [];
        partidas.forEach((p) => {
          const existeConcepto = partidasUnicas.findIndex((pm) => p.concepto === pm.concepto);
          if (existeConcepto === -1) {
            partidasUnicas.push({ concepto: p.concepto, fecha: p.fecha });
          }
        });
        let partidaFilterMasReciente = [];
        const partidasConFotos = [];
        partidasUnicas.forEach((pu) => {
          partidaFilterMasReciente = partidas
            .filter((pf) => pf.concepto === pu.concepto && pf.fecha === pu.fecha);
          partidasConFotos.push(partidaFilterMasReciente);
        });
        partidas = partidasConFotos.flat();
      } else {
        partidas = this.reportesFisicos
          .map(
            (r) => r.partidas.map((p) => (
              {
                idpartida: p.idPartida,
                concepto: p.partida.concepto,
                fecha: p.fecha ? p.fecha : r.fecha,
                avanceFisico: r.avanceFisico,
                imagenes: p.imagenes,
              }))
              .filter((p) => p.imagenes !== null),
          ).filter((p) => p.length > 0).flat(2)
          .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
      }
      const idsPartidas = [...new Set(partidas.map((partida) => (partida.idpartida)))];
      const lista = idsPartidas.map((id) => {
        const partidaImagenes = partidas
          .filter((p) => p.idpartida === id)
          .map((imagenes) => imagenes.imagenes
            .map((i) => ({ fecha: imagenes.fecha, imagen: i })));
        return ({ idpartida: id, imagenes: partidaImagenes });
      });
      const imagenesPartidas = lista
        .map((l) => ({ idpartida: l.idpartida, imagenes: l.imagenes.flat(1) }));

      const fotos = [{
        idpartida: '', concepto: '', avanceFisico: 0, imagenes: [],
      }];
      let noPartida = false;
      partidas.forEach((p) => {
        noPartida = true;
        fotos.forEach((f) => {
          if (p.idpartida === f.idpartida) {
            noPartida = false;
          }
        });
        if (noPartida) {
          const { imagenes } = imagenesPartidas.find((i) => i.idpartida === p.idpartida);
          fotos.push({
            idpartida: p.idpartida,
            concepto: p.concepto,
            avanceFisico: p.avanceFisico,
            imagenes,
          });
        }
      });
      return fotos.slice(1);
    },
  },
};
